import { computed, ref } from "vue";
import axios from "axios";
import store from "@/store";

export const useValueUnitDetail = () => {
  const valueUnitDetail = ref({});

  const setValueUnitDetail = ({
    folderItemId,
    id,
    type,
    source,
    data,
    thumbnail
  }) => {
    valueUnitDetail.value = {
      folderItemId,
      id,
      type,
      source,
      data,
      thumbnail
    };
  };

  const agendaToken = computed(() => store.state.tokenExchange.agendaToken);
  const selectToken = computed(() => store.state.tokenExchange.selectToken);

  const sourceTokenMap = computed(() => {
    const agenda = {
      token: agendaToken.value,
      source: "dpa-agenda"
    };
    const select = {
      token: selectToken.value,
      source: "dpa-select"
    };

    return {
      event: agenda,
      topic: agenda,
      text: select,
      picture: select,
      graphic: select
    };
  });

  const fetchValueUnitDetailData = async ({
    previewUrl,
    metadata,
    id,
    type,
    folderItemId
  }) => {
    const { token, source } = sourceTokenMap.value?.[type];
    const thumbnail = metadata.thumbnail
      ? { thumbnail: metadata.thumbnail }
      : {};

    const data = JSON.stringify(
      (
        await axios.get(previewUrl, {
          headers: {
            authorization: `Bearer ${token}`
          }
        })
      ).data
    );

    setValueUnitDetail({
      folderItemId,
      id,
      type,
      source,
      data,
      ...thumbnail
    });
  };

  const valueUnitDetailProps = computed(() => {
    let token = "";
    let detailType = "";
    switch (valueUnitDetail.value?.source) {
      case "dpa-agenda":
        token = agendaToken.value;
        detailType = "event";
        break;
      case "dpa-select":
        token = selectToken.value;
        detailType = "newsItem";
        break;
      default:
        break;
    }

    const { data, id, type, folderItemId } = valueUnitDetail.value;
    const imageThumbnail = valueUnitDetail.value?.thumbnail
      ? { imageThumbnail: valueUnitDetail.value?.thumbnail }
      : {};

    return {
      [detailType]: data,
      folderItemId,
      id,
      type,
      token,
      ...imageThumbnail
    };
  });

  return {
    setValueUnitDetail,
    valueUnitDetailProps,
    fetchValueUnitDetailData
  };
};
